import _ from 'lodash'
const VIDEO_VIMEO_CONFIG = {
    videos: _.selectAll( '.c-video--vimeo' ), 
    params: {
        controls: false,
        title: false,
        byline: false,
        portrait: false
    }
}
export default VIDEO_VIMEO_CONFIG